export default "__VITE_ASSET__D9tgzXJI__"